export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-33.df438a95.png";